import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { hiringCompanyJobfeedAutoCompleteInput$, hiringCompanyJobfeedAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const HiringCompanyJobfeedAutoSuggest = renderAutoSuggestWithOptions(
   hiringCompanyJobfeedAutoCompleteObservable$,
   hiringCompanyJobfeedAutoCompleteInput$,
);

HiringCompanyJobfeedAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: [],
   forceSelection: false,
   placeholder: 'Search Hiring Company...',
};

export default HiringCompanyJobfeedAutoSuggest;
